import styled from 'styled-components'
import { Avatar } from '@mui/material'

export const ProfilePicture = styled(Avatar).attrs({
  sx: { bgcolor: '#DBF9EA', color: '#27714B' }
})`
  width: 32px;
  height: 32px;
`
